import React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button";
import {compose} from "recompose";
import {withFirestore} from "../../firebase/context";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";

import ImageUploader from 'react-images-upload';

const values = [
    {name: 'koreanId', placeHolder: 'Korean Id', type: 'number', initial: 0},
    {name: 'name', placeHolder: 'Name', type: 'text', initial: ''},
    {name: 'nameHA', placeHolder: 'Name Hangul', type: 'text', initial: ''},
    {name: 'oneLiner', placeHolder: 'One Liner', type: 'text', initial: ''},
    {name: 'description', placeHolder: 'Description', type: 'text', initial: ''},
    {name: 'category', placeHolder: 'Category', type: 'text', initial: ''},
    {name: 'priceLevel', placeHolder: 'Price Level', type: 'number', initial: 0},
    {name: 'spicy', placeHolder: 'Spicy', type: 'boolean', initial: false},
    {name: 'veggie', placeHolder: 'Veggie', type: 'boolean', initial: false},
];


class DataForm extends React.Component {

    constructor(props) {
        super(props);
        let initialState = {
            image: undefined,
            message: '',
            error: '',
        };
        values.forEach((value) => {
            initialState[value.name] = value['initial'];
        });
        this.state = initialState;
    }


    render() {
        return (
            <div className="flex_column" style={{padding: 32}}>
                <form noValidate autoComplete="off">

                    <div className="flex_row">
                        <Typography
                            variant="title"
                            className="flex_column"
                            style={{marginBottom: 32}}>
                            Add food to database
                        </Typography>
                    </div>

                    {
                        values.map((value) => value.type === 'boolean' ?
                            <div key={value.name}/> : <TextField
                                key={value.name}
                                id={'food_field_' + value.name}
                                name={value.name}
                                // value={this.state[value.name]}
                                placeholder={value.placeHolder}
                                type={value.type}
                                style={{width: '100%', marginBottom: 32}}
                                onChange={(event) => this.handleChange(event)}/>
                        )
                    }


                    <div className="flex_row">
                        {
                            values.filter((value) => value.type === 'boolean').map((value) => <div
                                key={value.name}
                                style={{paddingRight: 32}}>
                                <Typography variant="subtitle1">
                                    {value.placeHolder}
                                </Typography>
                                <Checkbox
                                    checked={this.state[value.name]}
                                    onChange={(event) => this.setState({[value.name]: event.target.checked})}
                                    value="secondary"
                                    color="primary"
                                    inputProps={{'aria-label': 'secondary checkbox'}}
                                />
                            </div>)
                        }
                    </div>

                    <div className="flex_row">
                        <Typography>
                            Image: {this.state.image && (this.state.image.name || 'undefined')}
                        </Typography>
                    </div>

                    <ImageUploader
                        withIcon={true}
                        buttonText='Choose images'
                        onChange={this.onAddImages}
                        imgExtension={['.jpg', '.gif', '.png', '.gif']}
                        maxFileSize={5242880}
                    />

                    <div className="flex_row">
                        <Button className="flex_column"
                                variant={'outlined'}
                                onClick={(event) => this.handleAdd()}>
                            Add Food
                        </Button>
                    </div>

                    <div className="flex_row">
                        <Typography color={'error'}>
                            {this.state.error}
                        </Typography>
                    </div>
                    <div className="flex_row">
                        <Typography color={"default"}>
                            {this.state.message}
                        </Typography>
                    </div>


                </form>
            </div>
        );
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }


    onAddImages = images => {
        console.log('Adding image');
        this.setState({
            image: images.length > 0 ? images[0] : undefined,
        })

    };

    async handleAdd() {
        // reset error message
        this.setState({
            message: '',
            error: '',
        });

        // check for invalid fields
        const isAllFieldsValid = values.reduce((prev, current) => prev && this.state[current.name] !== '', true);
        if (!isAllFieldsValid) {
            this.setState({error: 'No fields can be empty!'});
            return;
        }

        if (!this.state.image) {
            this.setState({error: 'You have to add an image!'});
            return;
        }


        // construct food item
        let foodItem = {};
        values.forEach((value) => {
            const stringVal = this.state[value.name];
            foodItem[value.name] = value.type === 'number' ? parseInt(stringVal) : stringVal;
        });
        foodItem['priceLevelLow'] = foodItem['priceLevel'] === 0;
        foodItem['priceLevelMedium'] = foodItem['priceLevel'] === 1;
        foodItem['priceLevelHigh'] = foodItem['priceLevel'] === 2;

        if (!(foodItem['priceLevel'] === 0 || foodItem['priceLevel'] === 1 || foodItem['priceLevel'] === 2)) {
            this.setState({error: 'The price level has to be 0, 1 or 2!'});
            return;
        }


        // upload image
        console.log('Uploading image...');
        const imageRef = this.props.firestore.imageStorage(foodItem['koreanId']);
        await imageRef.put(this.state.image);
        // const uploadTask = await imageRef.put(this.state.image);

        // fetch download url for image
        console.log('Fetching download url...');
        foodItem['image'] = await imageRef.getDownloadURL();

        console.log('updating database...');
        this.props.firestore.foods().add(foodItem).then((ref) => {
            console.log('The following food item was added');
            console.log("item id: ", ref.id);
            console.log(foodItem);
            this.setState({message: 'The food was successfully added!'});
        }).catch((error) => {
            console.warn(error);
        });
    }


}

export default compose(
    withFirestore,
)(DataForm);
